import React from "react";
import { Card, CardHeader } from "../../UI/DesignStandards";
import { chooseLeagueSheetFiles } from "../../../utility/averageCatalogs";
import {
  AVERAGE_VERIFICATION_DIRECTOR_CONTACT,
  AVERAGE_VERIFICATION_MISSING_DIRECTOR,
  DEFAULT_AVERAGE_PROOF_MESSAGE,
  DEFAULT_OUT_OF_TOWN_PROOF_MESSAGE,
} from "../../../utility/signupSettings";

const EntryAverageProofCard = ({
  show = false,
  required = false,
  file = null,
  error = null,
  directorInstructions = "",
  onFileChange,
}) => {
  if (!show) return null;

  const handleChange = (event) => {
    const { accepted, rejected } = chooseLeagueSheetFiles(event.target.files);
    if (rejected.length) {
      onFileChange?.(null, rejected[0]);
      return;
    }
    onFileChange?.(accepted[0] || null, null);
  };

  const written = String(directorInstructions || "").trim();

  return (
    <Card className="mb-8">
      <CardHeader
        title={
          required
            ? "Average verification required"
            : "Average verification"
        }
        subtitle={
          required
            ? DEFAULT_AVERAGE_PROOF_MESSAGE
            : DEFAULT_OUT_OF_TOWN_PROOF_MESSAGE
        }
      />
      <div className="p-6 space-y-4">
        <div className="card-inset p-4 space-y-2 text-left">
          <p className="text-xs font-medium uppercase tracking-wide text-brand-muted">
            From the tournament director
          </p>
          {written ? (
            <>
              <p className="text-sm text-brand-charcoal whitespace-pre-wrap">
                {written}
              </p>
              <p className="text-sm text-brand-muted">
                {AVERAGE_VERIFICATION_DIRECTOR_CONTACT}
              </p>
            </>
          ) : (
            <p className="text-sm text-brand-muted">
              {AVERAGE_VERIFICATION_MISSING_DIRECTOR}
            </p>
          )}
        </div>
        <input
          type="file"
          accept=".pdf,.png,.jpg,.jpeg,application/pdf,image/png,image/jpeg"
          onChange={handleChange}
          required={required}
          className="block w-full text-sm text-brand-charcoal file:mr-4 file:py-2 file:px-3 file:rounded-lg file:border-0 file:bg-brand-gold file:font-display file:font-bold file:text-brand-charcoal"
        />
        {file ? (
          <p className="text-sm text-brand-muted">{file.name}</p>
        ) : null}
        {error ? (
          <p data-signup-error="" className="text-sm text-red-600">
            {error}
          </p>
        ) : null}
      </div>
    </Card>
  );
};

export default EntryAverageProofCard;
